import {chagas} from './Chagas';
import {esquistossomose} from './Esquistossomose';
import {leishTeg} from './LeishTeg';
import {leishVic} from './LeishVic';
import {leptospirose} from './Leptospirose';
import {malaria} from './Malaria';

function useGetData(puzzle){
  switch (puzzle) {
    case "Chagas":
      return chagas();
    case "Esquistossomose":
      return esquistossomose();
    case "LeishTeg":
      return leishTeg();
    case "LeishVic":
      return leishVic();
    case "Leptospirose":
      return leptospirose();
    case "Malaria":
      return malaria();
    default:
      return false;
  }
}

export{useGetData};
